import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'lookup' })
export class LookupPipe implements PipeTransform {
  /**
   * Finds the first item in a collection where a given property matches a value.
   *
   * Usage:
   *   collection | lookup : prop : value
   *
   * Example:
   *   (users | lookup:'email':email)?.name ?? email
   *
   * @param collection Array of objects to search
   * @param prop Property name to match (key of object)
   * @param value Value to match against the property
   * @returns The first matching item, or undefined if not found
   *
   * - Case-insensitive comparison for strings
   * - Strict comparison for other types
   */
  transform<T, K extends keyof T>(
    collection: readonly T[] | null | undefined,
    prop: K,
    value: T[K],
  ): T | undefined {
    return collection?.find((item) => {
      const target = item[prop];
      return typeof target === 'string' && typeof value === 'string'
        ? target.toLowerCase() === value.toLowerCase() // case‑insensitive for strings
        : target === value; // strict compare otherwise
    });
  }
}
